import { call, put, select, takeEvery } from "redux-saga/effects";
import * as actionTypes from "./ActionTypes"
import { Get_Profile_Preference_And_View_Profile, Initial_Matches, Matches_List, Matches_Profile, Matches_Score, Search_By_Id, Search_By_Name, Search_list, Selected_Matches, dynamicFilterMatches, not_specified_bulk_request, sagaPost } from "../../Helpers/api_helpers";
import { getFilterMatchesFail, getFilterMatchesSuccess, getMatchesFail, getMatchesSuccess, getProfileMatchFail, getProfileMatchPrefFail, getProfileMatchPrefSuccess, getProfileMatchSuccess, getRecommendedFail, getRecommendedSuccess, getSelectedMatchesFail, getSelectedMatchesSuccess, searchMatchesByTextFail, searchMatchesByTextSuccess, searchMatchesFail, searchMatchesSuccess, setCurrentMatch, storeRequestTypeFail, storeRequestTypeSuccess, toggleProfileSelectedFail, toggleProfileSelectedSuccess, viewPhoneFail, viewPhoneSuccess, viewProfileByIdFail, viewProfileByIdSuccess,bulkStoreRequestTypeSuccess,bulkStoreRequestTypeFail, getNotSpecifiedFieldsTypeSuccess, getNotSpecifiedFieldsTypeFail, featureToggleProfileSelectedSuccess, featureToggleProfileSelectedFail } from "./Action";
import EndPoints from "../../Constants/EndPoints";
import Constants, { FilterOptions } from "../../Constants/constants";
import { post_method } from "../../Helpers/axios_helpers";
import config from "../../config";
import { setCurrentChat } from "../Chats/Action";
import { logActivity } from "../../Components/KalyanRewards/PointEarnedNotification";
import { addPoint } from "../KalyanRewards/Action";
import { getOrCreateDeviceId, getNotificationBlockedStatus } from "../../Utils/deviceUtils";

const normalizeYN = (value) => {
    if (value === "Y" || value === "N") return value;
    if (value === true) return "Y";
    if (value === false) return "N";
    if (value == null) return "N";
    const str = String(value).trim().toUpperCase();
    if (str === "Y" || str === "YES" || str === "TRUE" || str === "1") return "Y";
    if (str === "N" || str === "NO" || str === "FALSE" || str === "0") return "N";
    return "N";
};

function* trackSelfPayMatchesFulfillment() {
    const trackingData = localStorage.getItem("selfPayMatchesFulfillment");

    if (!trackingData) {
        return;
    }

    try {
        const parsedData = JSON.parse(trackingData);
        const selfPayId = parsedData?.selfPayId;

        if (!selfPayId) {
            localStorage.removeItem("selfPayMatchesFulfillment");
            return;
        }

        const request = {
            email: parsedData?.email ?? localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
            userId: parsedData?.userId ?? localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
            selfPayId,
            isClicked: false,
            isfulfilled: true,
            loginFrom: parsedData?.loginFrom ?? localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
        };

        const response = yield call(sagaPost, {
            url: `${config.api.API_URL}${EndPoints.selfpaytrackingUrl()}`,
            request,
        });

        if (response?.data?.status === "Success" || response?.data?.statusCode === 200) {
            localStorage.removeItem("selfPayMatchesFulfillment");
        }
    } catch {
        // Matches page should continue even if self-pay fulfillment tracking fails.
    }
}

function* getMatches({ payload }) {
    try { // 
        const response = yield call(Matches_List, payload);
        if (response.data.status === "Success") {
            yield put(getMatchesSuccess(response.data));
        } else {
            yield put(getMatchesFail(response));
        }
    } catch (error) {
        yield put(getMatchesFail(error));
    }
}

function* getRecommendedMatches({ payload, logout }) {
    try {
        const request = {
            "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName) == "" ? null : localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
            "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
            "loginFrom": localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
            "recomendationpageno": payload.page,
            "status": "new",
            webKey: localStorage.getItem(Constants.loginLocalStorageKeys.fcmToken),
            shortlisted: payload?.shortlisted,
            ignored: payload?.ignored,
            viewed: payload?.viewed,
            deviceId: getOrCreateDeviceId(),              // ✅ NEW
            isNotificationBlocked: getNotificationBlockedStatus(), // ✅ NEW
            familyLoginId : localStorage.getItem(Constants.loginLocalStorageKeys.familyLoginId) ?? null // ✅ NEW

        }
        const response = yield call(Initial_Matches, request);

        if (response.data?.statusCode === 401) {
            logout();
            return;
        }

        if (response.data.status === "Success") {

            if (payload.openFirst && response.data?.data?.matcheslist?.length > 0) {
                yield put(setCurrentMatch({ match: response.data?.data?.matcheslist[0], matchdata: response.data?.data, category: Constants.matchCatogory.initial }))
            }
            if (response.data?.data) {
                const currentMatch = yield select((state) => state.KalyanLite?.currentMatch);                
                yield put(setCurrentMatch({ match:currentMatch.data, matchdata: response.data?.data, category:currentMatch?.category}))
            }
            if(response.data){
                response.data.isFrom = payload?.isFrom;
            }
            yield put(getRecommendedSuccess(response.data));
            yield call(trackSelfPayMatchesFulfillment);
            // 
            
        } else {
            yield put(getRecommendedFail(response));
        }
    } catch (error) {
        yield put(getRecommendedFail(error));
    }
}

function* getSelectedMatches({ payload, logout }) {
    try {
        const request = {
            "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
            "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
            "loginFrom": localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
            "selectedprofilespageno": payload.page,
            "status": "new",
            "limit": "10",
        }

        const response = yield call(Selected_Matches, request);

        if (response.data?.statusCode === 401) {
            logout();
            return;
        }

        if (response.data.status === "Success") {
            if (payload.openFirst && response.data?.data?.Selectedprofiles?.length > 0) {
                yield put(setCurrentMatch({ match: response.data?.data?.Selectedprofiles[0], category: Constants.matchCatogory.selectedMatch }))
            }
            yield put(getSelectedMatchesSuccess(response.data));
        } else {
            yield put(getSelectedMatchesFail(response));
        }
    } catch (error) {
        yield put(getSelectedMatchesFail(error));
    }
}

function* getMatchProfile({ payload, logout }) {
    try { // 
        const response = yield call(Matches_Profile, payload);

        if (response.data.statusCode === 401) {
            logout()
            return;
        }

        if (response.data?.data?.statusmessage == "same gender") {
            return;
        }

        if (response.data.status === "Success") {
            let partnerExpectationProfile = response.data?.data?.partnerExpectationProfile;
            try {
                const prefReq = {
                    email: localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
                    userId: localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
                    viewprofileid: payload?.viewprofileid,
                    loginFrom: payload?.loginFrom,
                };
                const prefRes = yield call(Get_Profile_Preference_And_View_Profile, prefReq);
                const prefData = prefRes?.data?.data;
                partnerExpectationProfile = normalizeYN(
                    prefData?.partnerExpectationProfile ??
                    prefData?.isProfileViewProfileMatch ??
                    partnerExpectationProfile ??
                    "N",
                );
            } catch (e) {
                partnerExpectationProfile = normalizeYN(partnerExpectationProfile ?? "N");
            }

            yield put(getProfileMatchSuccess({
                ...response.data,
                data: {
                    ...response.data?.data,
                    partnerExpectationProfile,
                }
            }));
        } else {
            yield put(getProfileMatchSuccess(response));
        }
        if(payload.callFrom !== "MatchPopup"){
        const response2 = yield call(Matches_Score, { ...payload, pageno: "2" });
        if (response2.data.status === "Success") {
            yield put(getProfileMatchSuccess({ isPagetwo: true, data: response2?.data?.data, userId: payload.viewprofileid }));
        }
       }
    } catch (error) {
        yield put(getProfileMatchFail(error));
    }
}

function* getMatchProfilePref({ payload, logout }) {
    try { // 
        const response = yield call(Matches_Score, { ...payload });
        if (response.data.statusCode === 401) {
            logout()
            return;
        }
        if (response.data.status === "Success") {
            yield put(getProfileMatchPrefSuccess({ request: payload, data: response?.data?.data }));
        }
    } catch (error) {
        yield put(getProfileMatchPrefFail(error));
    }
}



// /api/selectedrejected

function* toggleProfileSelected({ payload }) {
    try { // 
        const data = {
            url: EndPoints.selectRejectUrl(),
            request: {
                "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
                "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
                "type": payload?.selectedStatus ? "Selected" : "Select",
                "toProfileId": payload.profileId,
                "selectedVia": payload.selectedVia,
                "objectCode" : "CARE_CHAT"

            }
        }
        const response = yield call(sagaPost, data);
        if (response.data.status === "Success") {
            if (payload?.selectedStatus) {
                if (response.data.data.status === "success") {
                    put(addPoint({ activityId: 3 }))
                    yield put(toggleProfileSelectedSuccess(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage, payload?.selectedVia, payload?.profileData));
                }
                else {
                    yield put(toggleProfileSelectedFail(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage));
                }
            }
            else {
                yield put(toggleProfileSelectedSuccess(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage, payload?.selectedVia, payload?.profileData));
            }
        }
        else {
            yield put(toggleProfileSelectedFail(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage));
        }
    } catch (error) {
        yield put(toggleProfileSelectedFail(error));
    }
}

/// api feature/bulkselectedrejected

function* featureToggleProfileSelected({ payload }) {
    try { // 
        const data = {
            url: EndPoints.selectRejectUrl(),
            request: {
                "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
                "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
                "type": payload?.selectedStatus ? "Selected" : "Select",
                "toProfileId": payload.profileId,
                "selectedVia": payload.selectedVia,
                "objectCode" : "CARE_CHAT"

            }
        }
        const response = yield call(sagaPost, data);
        if (response.data.status === "Success") {
            if (payload?.selectedStatus) {
                if (response.data.data.status === "success") {
                    put(addPoint({ activityId: 3 }))
                    yield put(featureToggleProfileSelectedSuccess(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage));
                }
                else {
                    yield put(featureToggleProfileSelectedFail(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage));
                }
            }
            else {
                yield put( featureToggleProfileSelectedSuccess(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage));
            }
        }
        else {
            yield put(featureToggleProfileSelectedFail(payload?.profileId, payload?.selectedStatus, response?.data?.data?.statusMessage));
        }
    } catch (error) {
        yield put(  featureToggleProfileSelectedFail(error));
    }
}

function* toggleProfileRejected({ payload }) {
    try { // 
        const data = {
            url: EndPoints.selectRejectUrl(),
            request: {
                "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
                "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
                "type": payload?.rejectedStatus ? "Rejected" : "Reject",
                "toProfileId": payload.profileId,
                "objectCode" : "CARE_CHAT"

            }
        }
        const response = yield call(sagaPost, data);

    } catch (error) {

    }
}


function* viewPhone({ payload }) {
    try { // 
        const partnerExpectationProfile = yield select(
            (state) => state?.KalyanLite?.matchProfiles?.[payload.profileId]?.partnerExpectationProfile,
        );
        const data = {
            url: EndPoints.viewPhoneUrl(),
            request: {
                "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
                "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
                "phoneViewFrom": localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
                "toProfileId": payload.profileId,
                "partnerExpectationProfile": normalizeYN(partnerExpectationProfile ?? "N"),
                "fromCallPage" : payload.fromCallPage,
                "objectCode" : "CARE_CHAT"

            }
        }
        const response = yield call(sagaPost, data);
        if (response.data.status === "Success") {
            yield put(viewPhoneSuccess(response.data?.data));
        } else {
            yield put(viewPhoneFail(response));
        }
    } catch (error) {
        yield put(viewPhoneFail(error));
    }
}

function* toggleProfileBlock({ payload }) {
    try { // 
        const data = {
            url: payload.isBlocked ? EndPoints.unblockprofile() : EndPoints.blockprofile(),
            request: {
                "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
                "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
                "toProfileId": payload.profileId
            }
        }
        const response = yield call(sagaPost, data);

    } catch (error) {

    }
}


function* viewProfileById({ payload, logout, onSuccess }) {
    try { // 

        const request = {
            "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
            "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
            "pageno": "1",
            "toProfileId": payload.id,
            "loginFrom": payload.loginFrom,
            callFrom: "SearchById",
        }

        const response = yield call(Search_By_Id, request);

        if (response.data?.statusCode === 401) {
            yield put(viewProfileByIdFail(response?.data?.data?.statusmessage));
            logout();
            return;
        }

        if (response.data?.data?.status === "SUCCESS") {
            yield put(viewProfileByIdSuccess({ data: response.data?.data, smProfileId: payload.id, isChat: payload.isChat }));
            if (payload.isChat) {
                yield put(setCurrentChat(response?.data?.data?.profiledetails?.profileid))
                onSuccess(response?.data?.data?.profiledetails?.profileid)
            }
        } else {
            yield put(viewProfileByIdFail(response?.data?.data?.statusmessage));
        }
    } catch (error) {
        yield put(viewProfileByIdFail(error));
    }
}

function* searchMatchesByText({ payload, logout, onSuccess }) {
    try { // 

        const request = {
            "email": localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
            "userId": localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
            "pageno": payload.page,
            "loginFrom": localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
            "searchname": payload.text
        }


        const response = yield call(Search_By_Name, request);

        if (response.data?.statusCode === 401) {
            logout();
            return;
        }

        if (response.data?.data?.status === "SUCCESS") {
            if (payload.openFirst && response.data?.data?.searchmatches?.length > 0 && !payload.isMobileView) {
                yield put(setCurrentMatch({ match: response.data?.data?.searchmatches[0], category: Constants.matchCatogory.nameSearch }))
            }
            yield put(searchMatchesByTextSuccess({
                data: response.data?.data,
                smProfileId: payload.id,
                requestPayload: payload
            }));
            if (payload.isChat && !payload.isMobileView && payload.openFirst) {
                yield put(setCurrentChat(response?.data?.data?.searchmatches[0]?.profileid))
                onSuccess(response?.data?.data?.searchmatches[0]?.profileid)
            }
        } else {
            yield put(searchMatchesByTextFail(response?.data?.data?.statusmessage));
        }
    } catch (error) {
        yield put(searchMatchesByTextFail(error));
    }
}


function* getFilterMatches({ payload, logout }) {
    try { // 

        const currentFilter = FilterOptions.filter(data => data.key === payload.filterType)[0]

        const request = currentFilter?.getRequest({
            page: (currentFilter?.url === EndPoints.getviewedphoneprofileanddocumentv3() || currentFilter?.url === EndPoints.inboxRequestViewUrl() || currentFilter?.url === EndPoints.requestviewliteapp()) ? payload.page - 1 : payload.page,
            pageSize: Constants.matchRowCount,
            email: localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
            userId: localStorage?.getItem(Constants.loginLocalStorageKeys.loginId),
            shortlisted: payload.shortlisted,
            ignored: payload.ignored,
            viewed: payload.viewed,
        })

        const response = yield call(dynamicFilterMatches, { url: currentFilter?.url, request });

        if (response.data?.statusCode === 401) {
            logout();
            return;
        }

        if (response.data?.status === "Success") {
            let responseData = response.data?.data[currentFilter.responseKey];



            if (currentFilter?.url === EndPoints.getviewedphoneprofileanddocumentv3() || currentFilter?.url === EndPoints.inboxRequestViewUrl() || currentFilter?.url === EndPoints.requestviewliteapp()) {
                responseData = responseData?.map(data => ({
                    ...data,
                    profileurl: data?.profileurl || data?.profilepic,
                    profilename: data?.profilename || data?.name,
                    profileage: data?.profileage || data?.age,
                    profileheight: data?.profileheight || data?.height,
                    profilecaste: data?.profilecaste,
                    profilequalification: data?.profilequalification,
                    profileoccupation: data?.profileoccupation,
                    profilecity: data?.profilecity || data?.city,
                    profilelastOnline: data?.lastOnline || data?.profilelastOnline,
                    profileid: data?.profileid || data?.profileId,
                    profileStatus: data?.profileStatus || data?.profileStatus,
                    profilefromPasswordProtected: data?.profilefromPasswordProtected || data?.fromPasswordProtected,
                    profileblurPhoto: data?.profileblurPhoto || data?.blurPhoto
                }))
            }

            yield put(getFilterMatchesSuccess({
                data: responseData,
                filterType: payload.filterType,
                bannerWeb: response?.data?.data?.bannerWebNew,
                contentCard: response?.data?.data?.content ? response?.data?.data?.content : response?.data?.data?.contentCard,
                showcastemigration: response?.data?.showcastemigration,
                castedata: response?.data?.castedata,
                showpopup:response?.data?.popup,
                subcastedata: response?.data?.subcastedata,
            }));
            if (payload.openFirst && responseData?.length > 0) {
                yield put(setCurrentMatch({ match: responseData[0], category: Constants.matchCatogory.filterMatches, matchType: currentFilter.key }))
            }
        } else {
            yield put(getFilterMatchesFail(response?.data));
        }
    } catch (error) {
       
        yield put(getFilterMatchesFail(error));
    }
}

function* searchMatches({ payload, logout }) {

    try {
        let request = {
            ...payload.searchTerms,
            limit: 10,
            pageno: payload.page,
            loginFrom: payload.loginFrom
        }

        const response = yield call(Search_list, request)

        if (response.data?.statusCode === 401) {
            logout();
            return;
        }

        if (response.data.status === "Success") {
            yield put(searchMatchesSuccess(response?.data));
            const data = response?.data?.data?.filtermatches;
            if (payload.openFirst && data?.length > 0) {
                yield put(setCurrentMatch({ match: data[0], category: Constants.matchCatogory.basicSearch }))
            }
        } else {
            yield put(searchMatchesFail(response));
        }
    } catch (error) {
        yield put(searchMatchesFail(error));
    }
}

// STORE REQUEST TYPE

function* storeRequestType({ payload }) {
    try {
        const data = {
            url: EndPoints.StoreRequestUrl(),
            request: {
                "sender_profileid": payload?.sender_profileid,
                "receiver_profileid": payload?.receiver_profileid,
                "requesttypeid": payload?.requesttypeid,
                "loginFrom": payload?.loginFrom,
                "requestsentvia": payload?.requestsentvia,
                "fromPage" : payload?.fromPage,
                "objectCode" : "CARE_CHAT",
                "triggerType" : payload?.triggerType,
            }
        }
        const response = yield call(sagaPost, data);
        
        
        if (response.data.status === "Success") {
            // yield put(storeRequestTypeSuccess(payload));
            
            
            yield put(storeRequestTypeSuccess({ ...payload, responseData: response.data }));
        }
        else {
            yield put(storeRequestTypeFail(response));
        }
    } catch (error) {
        yield put(storeRequestTypeFail(error));
    }
}

// NOTIFICATION TRACKING
function* notificationClickedTracking({ payload }) {
    try {
        const data = {
            url: EndPoints.notificationClickedTrackingUrl(),
            request: {
                "recieverprofileid": payload?.recieverprofileid,
                "request_typeid": payload?.request_typeid,
                "fromList" : payload?.fromList,                
            }
        }
        const response = yield call(sagaPost, data);

    } catch (error) {

    }
}

// get Customer ProfileList
function* getCustomerProfileListData({ payload }) {
    try {
        const data = {
            url: EndPoints.getCustomerProfileListUrl(),
            request: {
                "kp_profileId": payload?.request?.kp_profileId,
                "filter": payload?.request?.filter,
                "key": payload?.request?.key,
                "limit": payload?.request?.limit,
                "pageno": payload?.request?.pageno    
            }
        }
        const response = yield call(sagaPost, data);
        payload?.onSuccess(response)

    } catch (error) {

    }
}

// get Customer ProfileList
function* saveCustomerResponse({ payload }) {
    try {
        const data = {
            url: EndPoints.saveCustomerResponseUrl(),
            request: {
                "response": payload?.request?.response,
                "logId": payload?.request?.logId,
                "kp_profileId": payload?.request?.kp_profileId,
                "source_profileId": payload?.request?.source_profileId,
                "key": payload?.request?.key,
                "admUserId": payload?.request?.admUserId
            }
        }
        const response = yield call(sagaPost, data);
        payload?.onSuccess(response)

    } catch (error) {

    }
}

function* isKpCustomerData({ payload }) {
    try {
        const data = {
            url: EndPoints.isKpCustomerUrl(),
            request:  {
                "userId":payload?.request?.userId,
                "autoCusLogId":payload?.request?.autoCusLogId,
                "key":payload?.request?.key
            }
             
        }
        const response = yield call(sagaPost, data);
        payload?.onSuccess(response)

    } catch (error) {

    }
}
function* bulkStoreRequestType({ payload }) {
    try {
        const data = {
            url: EndPoints.bulkStoreRequestUrl(),
            request: {
                "sender_profileid": payload?.sender_profileid,
                "receiver_profileid": payload?.receiver_profileid,
                "requesttypeidList": payload?.requesttypeidList,
                "loginFrom": payload?.loginFrom,
                "requestsentvia": payload?.requestsentvia,
                "fromPage" : payload?.fromPage,
                "objectCode" : "CARE_CHAT",
                "triggerType": payload?.triggerType
            }
        }
        const response = yield call(sagaPost, data);
        
        if (response.data.status === "Success") {
            // yield put(bulkStoreRequestTypeSuccess(payload));
            
            yield put(bulkStoreRequestTypeSuccess({ ...payload, responseData: response.data }));
        }
        else {
            yield put(bulkStoreRequestTypeFail(response));
        }
    } catch (error) {
        yield put(bulkStoreRequestTypeFail(error));
    }
}

function* kalyanLiteSaga() {
    yield takeEvery(actionTypes.GET_MATCHES, getMatches);
    yield takeEvery(actionTypes.GET_MATCH_PROFILE, getMatchProfile);
    yield takeEvery(actionTypes.TOGGLE_PROFILE_SELECTED, toggleProfileSelected)
    yield takeEvery(actionTypes.TOGGLE_PROFILE_REJECTED, toggleProfileRejected)
    yield takeEvery(actionTypes.TOGGLE_PROFILE_BLOCK, toggleProfileBlock)
    yield takeEvery(actionTypes.VIEW_PHONE, viewPhone)
    yield takeEvery(actionTypes.GET_RECOMMENDED_MATCHES, getRecommendedMatches)
    yield takeEvery(actionTypes.VIEW_PROFILE_BY_ID, viewProfileById)
    yield takeEvery(actionTypes.GET_SELECTED_MATCHES, getSelectedMatches)
    yield takeEvery(actionTypes.SEARCH_MATCHES_BY_TEXT, searchMatchesByText)
    yield takeEvery(actionTypes.GET_FILTER_MATCHES, getFilterMatches)
    yield takeEvery(actionTypes.SEARCH_MATCHES, searchMatches)

    yield takeEvery(actionTypes.GET_MATCH_PROFILE_PREF, getMatchProfilePref);
    yield takeEvery(actionTypes.STORE_REQUEST_TYPE, storeRequestType)
    yield takeEvery(actionTypes.NOTIFICATION_CLICKED_TRACKING, notificationClickedTracking)
    yield takeEvery(actionTypes.GET_CUSTOMER_PROFILE_LIST, getCustomerProfileListData)
    yield takeEvery(actionTypes.SAVE_CUSTOMER_RESPONSE, saveCustomerResponse)
    yield takeEvery(actionTypes.IS_KP_CUSTOMER, isKpCustomerData)
    yield takeEvery(actionTypes.BULK_STORE_REQUEST_TYPE, bulkStoreRequestType)
    yield takeEvery(actionTypes.FEATURE_TOGGLE_PROFILE_SELECTED, featureToggleProfileSelected)

    // yield takeEvery(actionTypes.GET_MATCH_PROFILE, getMatchProfile2);
}

export default kalyanLiteSaga;
